import cookieChange from './actions/cookieChange';
import cookieCreate from './actions/cookieCreate';
import cookieDetail from './actions/cookieDetail';
import cookiesList from './actions/cookiesList';
import getCookies from './getters/getCookies';
import cookiesUpload from './mutations/cookiesUpload';

const actions = {
    cookieChange,
    cookieCreate,
    cookieDetail,
    cookiesList
};

const mutations = {
    cookiesUpload
};

const getters = {
    getCookies
};

export default { actions, mutations, getters };
